export default __webpack_public_path__ + "grid-4-pjU.png";